// src/components/WelcomeSection.js
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useTranslation } from '../hooks/useTranslation';
import { Search, BarChart3, Shield } from 'lucide-react';
import { GradientIcon } from './ui';
// Remove CSS import since we're using Tailwind
// import './WelcomeSection.css';

const WelcomeSection = () => {
  const { theme } = useTheme();
  const t = useTranslation();
  
  return (
    <div className="py-6 text-center">
      {/* Feature cards grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-8">
        <div className="bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-6 text-left transition duration-200 hover:-translate-y-0.5 hover:shadow-md flex flex-col h-full">
          <GradientIcon 
            icon={<Search />} 
            variant="blue" 
            size="md" 
            className="mb-4"
          />
          <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-white">{t('welcomeSection.advancedSearch.title')}</h3>
          <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed flex-grow">{t('welcomeSection.advancedSearch.description')}</p>
        </div>
        
        <div className="bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-6 text-left transition duration-200 hover:-translate-y-0.5 hover:shadow-md flex flex-col h-full">
          <GradientIcon 
            icon={<BarChart3 />} 
            variant="purple" 
            size="md" 
            className="mb-4"
          />
          <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-white">{t('welcomeSection.confidenceScoring.title')}</h3>
          <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed flex-grow">{t('welcomeSection.confidenceScoring.description')}</p>
        </div>
        
        <div className="bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-6 text-left transition duration-200 hover:-translate-y-0.5 hover:shadow-md flex flex-col h-full">
          <GradientIcon 
            icon={<Shield />} 
            variant="green" 
            size="md" 
            className="mb-4"
          />
          <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-white">{t('welcomeSection.complianceReady.title')}</h3>
          <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed flex-grow">{t('welcomeSection.complianceReady.description')}</p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;